import React from 'react'
import { connect } from 'react-redux'
import { LocalForm, Control, actions } from 'react-redux-form'
import Errors from './Errors'
import { change_password } from '../actions'

const { M } = window
const { toast } = M

const mapStateToProps = state => {
  return {
    errors: state.user.errors,
    random: state.user.random
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changePassword: (id, values) => dispatch( change_password(id, values) )
  }
}

class ConnectedUserRowPasswordChange extends React.Component {
  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  handleSubmit(values) {
    const {password, password_confirmation} = values
    const {id} = this.props.user
    if (password !== password_confirmation) {
      return toast({
        html: "Password and Password Confirmation do not match"
      })
    }
    this.props.changePassword(id, values)
  }

  cancel() {
    this.formDispatch(actions.reset('localPass'));
    this.props.cancel()
  }

  componentDidUpdate(prevProps, prevState) {
    const {random} = this.props
    const prevRandom = prevProps.random
    if (prevRandom !== random) {
      this.cancel()
    }
  }

  render() {
    const {showPass, user, current_user, errors} = this.props;
    if (showPass === "hide") {
      return ''
    }

    const rowClass = "inlineForm " + showPass.replace('hide','hidden')

    const showErrors = (showPass === "") ? errors : []

    return (
      <tr className={rowClass}>
        <td colSpan={5}>
          <div>
            <LocalForm
            model="localPass"
            getDispatch={(dispatch) => this.attachDispatch(dispatch)}
            onSubmit = { (values) => {
              this.handleSubmit(values)
            }}
            autoComplete="off"
            initialState={{
              current_password: '',
              password: '',
              password_confirmation: '',
            }}
            >

              <div className="row inlineRow">
                <div className="col xl10 l10 s12 row">

                  <div className="col s12 l3 xl3 ">
                    <span className="passinfo">Setting password for {user.name}</span>
                  </div>

                  { (current_user.id === user.id) && (
                    <div className="input-field col s12 l3 xl3 ">
                      <label htmlFor={`current_${user.id}`} >Current Password</label>
                      <Control.text className="actuallyPassword" type="text" id={`current_${user.id}`} model= ".current_password" />
                    </div>
                    )
                  }

                  <div className="input-field col s12 l3 xl3 ">
                    <label htmlFor={`password_${user.id}`} >New Password</label>
                    <Control.text className="actuallyPassword" type="text" id={`password_${user.id}`} model= ".password"/>
                  </div>

                  <div className="input-field col s12 l3 xl3 ">
                    <label htmlFor={`password_confirmation_${user.id}`} >Password Confirmation</label>
                    <Control.text className="actuallyPassword" type="text" id={`password_confirmation_${user.id}`} model= ".password_confirmation"/>
                  </div>

                </div>
                <div className="col xl2 l2 s12 formButtons">
                  <button className="btn-small btn-flat" title="Change Password">
                    <i className="material-icons tiny c-light-green">save</i>
                  </button>
                  <a href="" className="btn-small btn-flat hover-red" title="Cancel" onClick={ e=> {
                    e.preventDefault()
                    this.cancel()
                  }}><i className="material-icons tiny c-red darken-1">cancel</i></a>
                </div>
              </div>

            </LocalForm>
          </div>
          <Errors errors={showErrors}/>

        </td>
      </tr>
    )
  }

}

const UserRowPasswordChange = connect(mapStateToProps, mapDispatchToProps)(ConnectedUserRowPasswordChange)

export default UserRowPasswordChange



// WEBPACK FOOTER //
// ./src/js/components/UserRowPasswordChange.js